/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext, useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { ContentZoneContext } from "cms/components/context/index";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";

const IconCTAComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const description = component?.description;
    const imageGuid = component?.image;
    const linkGuid = component?.link;
    const title = component?.title;

    const [image, setImage] = useState();
    const [link, setLink] = useState();
    const { token = "" } = useAuth();

    useEffect(() => {
        async function fetchData () {
            if (imageGuid) {
                const data = await SimpliCityAdminSDK.images.findOne(token, imageGuid);
                setImage(data);
            }
        }
        fetchData();
    }, [token, imageGuid]);

    useEffect(() => {
        const fetchData = async () => {
            if (!link) {
                if (linkGuid) {
                    const _link = await SimpliCityAdminSDK.link.findOne(token, linkGuid);
                    setLink(_link);
                }
            }
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='icon-cta-component-display'>
            {image &&
                <div className='icon-cta-image'>
                    <img
                        src={image.url}
                        alt={image?.alt || "SimpliCity image"}
                    />
                </div>
            }

            <div className='icon-cta-text-wrapper'>
                {title && <h2>{title}</h2>}
                {description && <RichTextPreview richtext={description} />}
            </div>

            {link && <a className='icon-cta-link' href={link?.url}>{link?.text}</a>}
        </div>
    );
};
IconCTAComponentDisplay.displayName = "IconCTAComponentDisplay";
export { IconCTAComponentDisplay };
